import {
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

const userProfileSchema = vObject({
  firstName: vString(),
  lastName: vString(),
  role: vString(),
})

export const profileUpdateSchema = vObject({
  profile: userProfileSchema,
  carrierName: vOptional(vString()),
})
export type ProfileUpdateDto = vOutput<typeof profileUpdateSchema>
